import {
  Component,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio'
import { TranslationService } from '../../../../services/translation.service'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms'
import { MatError } from '@angular/material/form-field'

@Component({
  selector: 'app-province-recyclability-info',
  imports: [
    MatRadioButton,
    MatRadioGroup,
    FormsModule,
    ReactiveFormsModule,
    MatError,
  ],
  templateUrl: './province-recyclability-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './province-recyclability-info.component.scss',
})
export class ProvinceRecyclabilityInfoComponent {
  translationService = inject(TranslationService)
  private fb = inject(FormBuilder)

  @Input() province?: string
  @Input() formGroup?: FormGroup
  @Input() submitted: boolean = false

  provincialRecyclability = this.fb.group({})
}
